import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UserType } from '../../../api/user/user-type';
import { CaseService } from '../../../services/data/case.service';
import { ServiceStageValue } from '../../../api/service-stage';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    standalone: false
})
export class RedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private caseService: CaseService,
  ) { }

  public ngOnInit(): void {
    this.activatedRoute.queryParams
    // .map(param => param.route)
      .subscribe((params) => {
        // Scope Redirects top level check
        if (params.scope && params.scopeId) {
          this.handleRedirectFromScopeAndId(params);
          return;
        }

        if (params.scope && (params.caseId || params.preliminaryAssessmentId)) {
          this.handleRedirectFromScopeParams(params);
          return;
        }

        // Params.query is a json string. We need to parse it.
        let query = null;
        if (params.query) {
          query = JSON.parse(params.query);
        }

        this.handleRedirect(params.route, query);
      });
  }

  /**
   * Handles the redirection for the specified route
   *
   * @param {string} route
   * @param {any} query JSON object
   *
   */
  public handleRedirect(route: string, query?: any): void {
    this.router.navigate([route], {queryParams: query});
  }

  private handleRedirectFromScopeAndId(params: Params): void {
    const caseId = params.scopeId;
    const user = this.authService.currentUser;

    let pathType = 'internal';
    if (user.userType === UserType.Company) {
      pathType = 'company';
    }

    if (params.scope === 'CASE') {
      const isDraft = params.draft;
      if (isDraft) {
        if (pathType === 'company') {
          this.router.navigate(['main', 'company', 'create-case', caseId]);
        } else {
          this.router.navigate(['main', 'create-case', caseId]);
        }
        return;
      }

      this.router.navigate(['main', 'case', caseId]);
      return;
    }

    if (params.scope === 'ADS_CASE') {
      this.router.navigate(['park-ads', pathType, 'case', caseId]);
    }

    if (params.scope === 'ADS_SERVICE') {
      const queryParams: Params = { serviceId: caseId };
      this.router.navigate(['park-ads', pathType, 'case', params.parentScopeId, 'ads'], {queryParams});
    }
  }

  private handleRedirectFromScopeParams(params: Params): void {
    const isCompany = this.authService.currentUser.userType === UserType.Company;

    if (params.scope === 'CASE') {
      const { caseId } = params;
      if (!caseId) {
        this.router.navigate(['main']);
        return;
      }
      this.caseService.get(+caseId).subscribe(caseData => {
        const stage = caseData.caseServices?.[0]?.currentStage?.serviceStage;
        const isIntakeStage = caseData.draft === true ||
          stage === ServiceStageValue.Intake || stage === ServiceStageValue.IntakeClient;

        if (isCompany) {
          if (isIntakeStage) {
            this.router.navigate(['main', 'company', 'create-case', caseId]);
          } else {
            this.router.navigate(['main', 'company', 'case', caseId, 'tracker']);
          }
        } else if (isIntakeStage) {
          this.router.navigate(['main', 'create-case', caseId]);
        } else {
          this.router.navigate(['main', 'case', caseId]);
        }
      });
      return;
    }

    if (params.scope === 'PRELIMINARY_ASSESSMENT') {
      const { companyId, preliminaryAssessmentId } = params;
      if (!preliminaryAssessmentId) {
        this.router.navigate(['main']);
        return;
      }
      if (isCompany) {
        this.router.navigate(
          ['main', 'company', 'parkedge-preliminary-assessment', 'assessment', preliminaryAssessmentId],
          { queryParams: { returnUrl: '/main/company/parkedge-dashboard' } }
        );
      } else {
        if (!companyId) {
          this.router.navigate(['main']);
          return;
        }
        this.router.navigate(
          ['main', 'customer-profile', companyId, 'preliminary-assessment', preliminaryAssessmentId],
          { queryParams: { returnUrl: `/main/customer-profile/${companyId}/preliminary-assessment` } }
        );
      }
      return;
    }

    this.router.navigate(['main']);
  }
}
